module.exports = __webpack_public_path__ + "static/img/Silver III.829a961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Silver III.png
// module id = HBgH
// module chunks = 35